<template>
  <ul class="navbar-nav" id="topNav-navbarList">
    <router-link to="/new" v-if="isRoleBasedAccessAllowed(roles.NEW)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-NEW">
      <a class="nav-link" id="topNav-navbarLink-NEW">{{ 'NEW' | translate('nav') }}</a>
    </router-link>
    <router-link to="/import" v-if="isRoleBasedAccessAllowed(roles.IMPORT)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-IMPORT">
      <a class="nav-link" id="topNav-navbarLink-IMPORT">{{ 'IMPORT' | translate('nav') }}</a>
    </router-link>
    <router-link to="/analyse" v-if="isRoleBasedAccessAllowed(roles.ANALYSE)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-ANALYSE">
      <a class="nav-link" id="topNav-navbarLink-ANALYSE">{{ 'ANALYSE' | translate('nav') }}</a>
    </router-link>
    <router-link to="/customer"  v-if="isRoleBasedAccessAllowed(roles.CUSTOMER)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-CUSTOMER">
      <a class="nav-link" id="topNav-navbarLink-CUSTOMER">{{ 'CUSTOMER' | translate('nav') }}</a>
    </router-link>
    <router-link to="/cases" v-if="isRoleBasedAccessAllowed(roles.CASES)"
                  tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-CASES">
      <a class="nav-link" id="topNav-navbarLink-CASES">{{ 'CASES' | translate('nav') }}</a>
    </router-link>
    <router-link to="/export" v-if="isRoleBasedAccessAllowed(roles.EXPORT)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-EXPORT">
      <a class="nav-link" id="topNav-navbarLink-EXPORT">{{ 'EXPORT' | translate('nav') }}</a>
    </router-link>
    <router-link to="/batch"
                 v-if="isRoleBasedAccessAllowed(roles.BATCH)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-BATCH">
      <a class="nav-link" id="topNav-navbarLink-BATCH">{{ 'BATCH' | translate('nav') }}</a>
    </router-link>
    <router-link to="/action"
                 v-if="isRoleBasedAccessAllowed(roles.ACTION)"
                 tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-ACTION">
      <a class="nav-link" id="topNav-navbarLink-ACTION">{{ 'ACTION' | translate('nav') }}</a>
    </router-link>
    <router-link to="/admin" v-if="isAdmin" tag="li" active-class="active" class="nav-item" id="topNav-navbarItem-ADMIN">
      <a class="nav-link" id="topNav-navbarLink-ADMIN">{{ 'ADMIN' | translate('nav') }}</a>
    </router-link>
  </ul>
</template>

<script>
  import KeycloakService from '../service/keycloak/KeycloakService';
  import { PageRoles } from '../service/keycloak/PageRoles';

  export default {
    name: 'TopNav',
    data: function () {
      return {
        roles: PageRoles
      }
    },
    computed: {
      isAdmin: function () {
        return KeycloakService.isAdmin();
      }
    },
    methods: {
      isRoleBasedAccessAllowed(roles) {
        return KeycloakService.isRoleBasedAccessAllowed(roles);
      }
    }
  }
</script>

<style scoped>
  .navbar-nav .nav-link {
    padding-top: .58rem;
    padding-bottom: .42rem;
    font-size: 15px;
    text-transform: uppercase;
    color: #616161;
  }
  @media (min-width: 992px) {
    .navbar-nav .nav-link {
      padding-right: .8rem;
      padding-left: .8rem;
    }
  }
  .navbar-nav .nav-link:hover {
    text-shadow: 1px 0 0 #616161;
    transform: translateX(-.5px);
  }
  .navbar-nav .nav-item.active > .nav-link {
    color: #00979D;
    text-shadow: 1px 0 0 #00979D;
    transform: translateX(-.5px);
  }
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue